import * as yup from "yup";
import { isCurrentYear } from "../../../utils/helpers";
export const HolidayValidationSchema = yup.object({
    holidayName:yup.string().trim().required("Holiday name is required"),
    holidayDate:yup.string().trim().required("Holiday date is required").test("is-current-year", "Holiday must be within the current year", (value) => {
        if (!value) return false;
        return isCurrentYear(value);
    })
})
export const TaskValidationSchema = yup.object({
    taskName:yup.string().trim().required("Task name is required")
})